import { SxProps, Theme } from "@mui/material";
import { assessmentPhoneLandscapeMedia, assessmentTabletLandscapeMedia } from "../assessment-layout-styles";

export const modalContainerStyle: SxProps<Theme> = {
  width: "100%",
  maxWidth: "100%",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  borderRadius: 0,
};

export const modalInnerStyle: SxProps<Theme> = {
  px: { xs: 2.5, sm: 4, md: 5 },
  pb: { xs: 2.5, sm: 4, md: 5 },
  pt: 0,
};

export const contestTopBarWrapStyle: SxProps<Theme> = {
  mb: { xs: 1.5, sm: 2, md: 0 },
  [assessmentPhoneLandscapeMedia]: {
    mb: 2,
  },
  [assessmentTabletLandscapeMedia]: {
    mb: 2,
  },
};

export const topBarStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  mb: 4,
  flexWrap: "wrap",
};

export const pageTitleStyle: SxProps<Theme> = {
  fontSize: "22px",
  fontWeight: 700,
};

export const chipRowStyle: SxProps<Theme> = {
  display: "flex",
  gap: 1,
  flexWrap: "wrap",
};

export const rankChipStyle = (theme: Theme) => ({
  borderRadius: "999px",
  backgroundColor: "rgba(6, 182, 212, 0.10)",
  color: theme.palette.quizPopap.quizText,
  fontWeight: 700,
});

export const resumeChipStyle = (theme: Theme) => ({
  borderRadius: "999px",
  backgroundColor: "rgba(123, 73, 193, 0.10)",
  color: theme.palette.quizPopap.quizText,
  fontWeight: 700,
});

export const heroCardStyle: SxProps<Theme> = {
  borderRadius: "24px",
  background:
    "linear-gradient(180deg, rgba(40, 201, 220, 0.08) 0%, rgba(123, 73, 193, 0.04) 100%)",
  border: "1px solid rgba(40, 201, 220, 0.14)",
  px: { xs: 2, sm: 4, md: 5 },
  py: { xs: 3, sm: 4, md: 5 },
};

export const trophyRowStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  mb: 2,
};

export const trophyWrapStyle: SxProps<Theme> = {
  width: 88,
  height: 88,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background:
    "linear-gradient(180deg, rgba(40, 201, 220, 0.18) 0%, rgba(123, 73, 193, 0.14) 100%)",
  color: "#06B6D4",
};

export const heroTextWrapStyle: SxProps<Theme> = {
  textAlign: "center",
  mb: 4,
};

export const heroTitleStyle: SxProps<Theme> = {
  fontSize: { xs: "28px", sm: "34px" },
  lineHeight: 1.1,
  fontWeight: 800,
  mb: 1,
};

export const heroSubtitleStyle: SxProps<Theme> = {
  fontSize: { xs: "15px", sm: "17px" },
  opacity: 0.78,
  maxWidth: "720px",
  mx: "auto",
};

export const statsGridStyle = (columns = 4): SxProps<Theme> => ({
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    md: `repeat(${columns}, minmax(0, 1fr))`,
  },
  gap: 2,
  mb: 3,
  [assessmentTabletLandscapeMedia]: {
    gap: 1,
  },
});

export const statCardStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  p: 2,
  borderRadius: "16px",
  border: "1px solid rgba(40, 201, 220, 0.18)",
  background:
    "linear-gradient(180deg, rgba(40, 201, 220, 0.06) 0%, rgba(123, 73, 193, 0.03) 100%)",
  minWidth: 0,
  [assessmentTabletLandscapeMedia]: {
    gap: 0.75,
    p: 1,
  },
};

export const statIconWrapStyle: SxProps<Theme> = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#06B6D4",
  backgroundColor: "rgba(6, 182, 212, 0.12)",
  flexShrink: 0,
  [assessmentTabletLandscapeMedia]: {
    width: 32,
    height: 32,
    "& svg": {
      width: 16,
      height: 16,
    },
  },
};

export const statTextWrapStyle: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

export const statValueStyle: SxProps<Theme> = {
  fontSize: "24px",
  lineHeight: 1.1,
  fontWeight: 700,
  color: "#06B6D4",
  mr: 0.5,
  fontFamily: '"Red Hat Display", sans-serif',
  fontSynthesis: "none",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  [assessmentTabletLandscapeMedia]: {
    fontSize: "12px",
    letterSpacing: "-0.01em",
    overflow: "visible",
    textOverflow: "clip",
  },
};

export const statLabelStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 500,
  color: "inherit",
  opacity: 0.78,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  [assessmentTabletLandscapeMedia]: {
    fontSize: "10px",
    letterSpacing: "-0.01em",
    overflow: "visible",
    textOverflow: "clip",
  },
};

export const detailGridStyle: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
  gap: 2,
  mb: 4,
};

export const detailCardStyle: SxProps<Theme> = (theme) => ({
  p: 2.5,
  borderRadius: "20px",
  backgroundColor: theme.palette.quizPopap.quizInsideBg,
  border: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
});

export const sectionTitleStyle: SxProps<Theme> = {
  fontSize: "16px",
  fontWeight: 800,
  mb: 2,
};

export const rulesListStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const ruleRowStyle: SxProps<Theme> = {
  display: "flex",
  gap: 1.5,
  alignItems: "flex-start",
};

export const ruleIconStyle: SxProps<Theme> = {
  color: "#06B6D4",
  mt: 0.25,
  flexShrink: 0,
};

export const ruleTitleStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 700,
};

export const ruleDescriptionStyle: SxProps<Theme> = {
  fontSize: "13px",
  opacity: 0.72,
};

export const leaderboardHeaderStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  mb: 1,
};

export const liveChipStyle: SxProps<Theme> = {
  backgroundColor: "rgba(34, 197, 94, 0.12)",
  color: "#16A34A",
  fontWeight: 700,
};

export const leaderboardRowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  py: 1,
};

export const leaderboardRowLeftStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const leaderboardPlaceBadgeStyle = (place: number) => ({
  width: 26,
  height: 26,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "13px",
  fontWeight: 800,
  color: place === 1 ? "#8A5A00" : place === 2 ? "#4B5563" : "#7C2D12",
  backgroundColor:
    place === 1
      ? "rgba(250, 204, 21, 0.20)"
      : place === 2
        ? "rgba(148, 163, 184, 0.20)"
        : "rgba(251, 146, 60, 0.20)",
});

export const leaderboardNameStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 600,
};

export const leaderboardPointsStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 700,
  color: "#06B6D4",
};

export const leaderboardEmptyStyle: SxProps<Theme> = {
  fontSize: "14px",
  opacity: 0.7,
  py: 2,
};

export const actionsRowStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  gap: 2,
  flexWrap: "wrap",
  mb: 2,
};

export const primaryButtonStyle: SxProps<Theme> = {
  minWidth: 220,
  px: 3,
  py: 1.25,
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 700,
  color: "#FFFFFF",
  backgroundColor: "#06B6D4",
  "&:hover": {
    backgroundColor: "#06B6D4",
    opacity: 0.9,
  },
};

export const primaryButtonIconWrapStyle: SxProps<Theme> = {
  ml: 1.5,
  width: 32,
  height: 32,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const secondaryButtonStyle = (theme: Theme) => ({
  minWidth: 160,
  px: 3,
  py: 1.25,
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 700,
  borderColor: theme.palette.quizPopap.quizSeparator,
  color: theme.palette.quizPopap.quizText,
});

export const footerNoteStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  fontSize: "13px",
  opacity: 0.7,
};

export const footerNoteIconStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};
